import { render, staticRenderFns } from "./DelegationOrderTravelServiceImport.vue?vue&type=template&id=be620d5a&scoped=true&"
import script from "./DelegationOrderTravelServiceImport.vue?vue&type=script&lang=js&"
export * from "./DelegationOrderTravelServiceImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be620d5a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VCheckbox,VCol,VDataTable,VDialog,VIcon,VSpacer,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('be620d5a')) {
      api.createRecord('be620d5a', component.options)
    } else {
      api.reload('be620d5a', component.options)
    }
    module.hot.accept("./DelegationOrderTravelServiceImport.vue?vue&type=template&id=be620d5a&scoped=true&", function () {
      api.rerender('be620d5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/DelegationOrder/DelegationOrderTravelServiceImport.vue"
export default component.exports